<template>
  <div class="ws-root">
    <div class="ws-bar">
      <el-input v-model="url" size="small" placeholder="wss://echo.websocket.org" class="ws-url" @keyup.enter="toggle" />
      <el-button :type="connected ? 'danger' : 'primary'" size="small" @click="toggle" :loading="connecting" plain>
        {{ connected ? $t('tool.WebsocketTester.btnDisconnect') : $t('tool.WebsocketTester.btnConnect') }}
      </el-button>
    </div>

    <div class="ws-status-bar">
      <span :class="connected ? 'ws-live' : 'ws-idle'">{{ connected ? $t('tool.WebsocketTester.statusConnected') : $t('tool.WebsocketTester.statusDisconnected') }}</span>
      <span v-if="messages.length" class="ws-count">{{ messages.length }}{{ $t('tool.WebsocketTester.messageCount') }}</span>
      <el-button v-if="messages.length" type="text" size="mini" style="margin-left:auto;color:#909399;" @click="messages=[]">{{ $t("common.action.clear") }}</el-button>
    </div>

    <div class="ws-log" ref="log">
      <div v-if="!messages.length" class="ws-hint">
        <div class="ws-hint-icon">~</div>
        <div class="ws-hint-text">{{ $t('tool.WebsocketTester.emptyHint') }}</div>
      </div>
      <div v-for="(m, i) in messages" :key="i" :class="['ws-msg', m.dir]">
        <div class="ws-arrow">{{ m.dir === 'send' ? '&#8593;' : '&#8595;' }}</div>
        <div class="ws-bubble">{{ m.text }}</div>
      </div>
    </div>

    <div class="ws-input-row" v-if="connected">
      <el-input v-model="input" size="default" :placeholder="$t('tool.WebsocketTester.phMessage')" @keyup.enter.native="send">
        <el-button slot="append" icon="el-icon-position" @click="send">{{ $t("common.action.submit") }}</el-button>
      </el-input>
    </div>
  </div>
</template>

<script>
function time() {
  var d = new Date()
  return ('0'+d.getHours()).slice(-2)+':'+('0'+d.getMinutes()).slice(-2)+':'+('0'+d.getSeconds()).slice(-2)
}

export default {
  name: 'WebsocketTester',
  props: { config: { type: Object, default: function() { return {} } } },
  data: function() {
    return { url: 'wss://echo.websocket.org', input: '', connected: false, connecting: false, messages: [], socket: null }
  },
  beforeDestroy: function() { this.disconnect() },
  methods: {
    toggle: function() { this.connected ? this.disconnect() : this.connect() },
    connect: function() {
      var u = this.url.trim(); if (!u) return
      this.connecting = true
      var ws
      try { ws = new WebSocket(u) } catch (e) {
        this.connecting = false; this.log('recv', this.$t('tool.WebsocketTester.errConnect') + ': ' + e.message); return
      }
      var self = this
      ws.onopen = function() { self.connecting = false; self.connected = true; self.socket = ws; self.log('recv', self.$t('tool.WebsocketTester.logConnected') + ' ' + u) }
      ws.onmessage = function(e) { self.log('recv', e.data) }
      ws.onerror = function() { self.log('recv', self.$t('tool.WebsocketTester.logAbnormal')) }
      ws.onclose = function() { self.connected = false; self.connecting = false; self.socket = null; self.log('recv', self.$t('tool.WebsocketTester.logClosed')) }
    },
    disconnect: function() { if (this.socket) this.socket.close(); this.connected = false; this.connecting = false },
    send: function() {
      var t = this.input.trim(); if (!t || !this.socket) return
      this.socket.send(t); this.log('send', t); this.input = ''
    },
    log: function(dir, text) {
      this.messages.push({ dir: dir, text: text, time: time() }); var self = this
      this.$nextTick(function() { var el = self.$refs.log; if (el) el.scrollTop = el.scrollHeight })
    },
    doAction: function(a) { if (a === 'clear') { this.messages = []; this.disconnect() } }
  }
}
</script>

<style>
.ws-root { width: 100%; }

.ws-bar { display: flex; gap: 10px; }
.ws-url { flex: 1; }
.ws-url >>> input { font-family: 'SF Mono','Consolas',monospace; font-size: 14px; }

.ws-status-bar { display: flex; align-items: center; gap: 14px; margin-top: 14px; }
.ws-live, .ws-idle { font-size: 13px; font-weight: 600; display: flex; align-items: center; gap: 6px; }
.ws-live::before { content: ''; width: 8px; height: 8px; border-radius: 50%; background: #67c23a; box-shadow: 0 0 8px rgba(103,194,58,.5); }
.ws-live { color: #67c23a; }
.ws-idle::before { content: ''; width: 8px; height: 8px; border-radius: 50%; background: #c0c4cc; }
.ws-idle { color: #909399; }
.ws-count { font-size: 12px; color: #b0b8c4; }

.ws-log { margin-top: 12px; border: 1px solid #ebeef5; border-radius: 12px; padding: 16px; min-height: 280px; max-height: 420px; overflow: auto; background: #fafbfc; }

.ws-hint { text-align: center; padding: 80px 20px; }
.ws-hint-icon { font-size: 32px; color: #dcdfe6; margin-bottom: 12px; }
.ws-hint-text { font-size: 14px; color: #c0c4cc; }

.ws-msg { display: flex; gap: 10px; align-items: flex-start; margin-bottom: 10px; }
.ws-msg.send { flex-direction: row-reverse; }
.ws-arrow { width: 22px; height: 22px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 12px; flex-shrink: 0; font-weight: 700; }
.ws-msg.recv .ws-arrow { background: #f0fdf4; color: #67c23a; }
.ws-msg.send .ws-arrow { background: #e8f0fe; color: #4e7cff; }

.ws-bubble { max-width: 85%; padding: 8px 14px; border-radius: 10px; font-size: 13px; line-height: 1.6; word-break: break-all; font-family: 'SF Mono','Consolas',monospace; white-space: pre-wrap; }
.ws-msg.recv .ws-bubble { background: #fff; color: #303133; border: 1px solid #e4e7ed; border-top-left-radius: 2px; }
.ws-msg.send .ws-bubble { background: #4e7cff; color: #fff; border-top-right-radius: 2px; }

.ws-input-row { margin-top: 12px; }
.ws-input-row >>> .el-input__inner { font-family: monospace; }

@media (max-width: 640px) {
  .ws-bubble { max-width: 75%; }
}
</style>
